var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMail24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F1C036"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 17a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V8.209c.105.077.19.138.271.204 1.998 1.586 4 3.166 5.992 4.762.544.436 1.048.45 1.588-.007 1.922-1.626 3.865-3.227 5.8-4.838.105-.088.212-.174.349-.287V17z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.639 7H18.37c-2.114 1.75-4.176 3.455-6.263 5.18L5.639 7z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMail24);
export default __webpack_public_path__ + "static/media/ic_mail_24.d3faa0aef0076d3ee6a61f36d1e0facd.svg";
export { ForwardRef as ReactComponent };